import apiClient, { unwrap } from './client'
import type { User } from './types'

export const usersApi = {
  list(page = 1, pageSize = 50) {
    return unwrap<User[]>(
      apiClient.get('/users', { params: { page, page_size: pageSize } }),
    )
  },

  create(data: {
    domain_id: number
    username: string
    password: string
    display_name?: string
    quota_bytes?: number
  }) {
    return unwrap<{ id: number }>(apiClient.post('/users', data))
  },

  get(id: number) {
    return unwrap<User>(apiClient.get(`/users/${id}`))
  },

  update(id: number, data: {
    display_name?: string
    quota_bytes?: number
    active?: boolean
  }) {
    return unwrap<{ updated: boolean }>(apiClient.put(`/users/${id}`, data))
  },

  delete(id: number) {
    return unwrap<{ deleted: boolean }>(apiClient.delete(`/users/${id}`))
  },
}
